import { render, staticRenderFns } from "./SportsTherapyComp.vue?vue&type=template&id=21519f16&scoped=true"
import script from "./SportsTherapyComp.vue?vue&type=script&lang=js"
export * from "./SportsTherapyComp.vue?vue&type=script&lang=js"
import style0 from "./SportsTherapyComp.vue?vue&type=style&index=0&id=21519f16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21519f16",
  null
  
)

/* custom blocks */
import block0 from "./SportsTherapyComp.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports